"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PasswordProtection;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Button = _interopRequireDefault(require("../Button"));

var _AttachmentPasswordForm = _interopRequireDefault(require("../AttachmentPasswordForm"));

function PasswordProtection(_ref) {
  var password = _ref.password,
      _onChangePassword = _ref.onChangePassword,
      onShowPasswordProtectionDialog = _ref.onShowPasswordProtectionDialog;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center cursor-pointer",
    onClick: function onClick() {
      if (onShowPasswordProtectionDialog) {
        if (onShowPasswordProtectionDialog()) {
          setOpen(true);
        }
      } else {
        setOpen(true);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_Lock["default"], {
    fontSize: "small",
    color: "primary"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary font-semibold text-sm ml-2"
  }, t('compose.attachmentBox.passwordProtection'))), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullScreen: false,
    maxWidth: false,
    open: isOpen,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-lg"
  }, "Password Protection"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-medium text-sm"
  }, "Only people with the password will be able to view and download these attachments"), /*#__PURE__*/_react["default"].createElement(_AttachmentPasswordForm["default"], {
    defaultPassword: password,
    onChangePassword: function onChangePassword(password) {
      _onChangePassword(password);

      setOpen(false);
    },
    onCancel: function onCancel() {
      return setOpen(false);
    }
  }))));
}
//# sourceMappingURL=PasswordProtection.js.map